import { REWARD_OFFERING } from "../constants";
import CompetitionPage from "../common/components/CompetitionPage";

function WeekFourMain() {
  const offerId = REWARD_OFFERING.weekfour;

  return (
    <CompetitionPage 
      offerId={offerId}
    />
  );
}

export default WeekFourMain;